<div class="text-center">
  <div class="login-bg-image"></div>
  <div>
    <div class="wrapper">
      <div class="console">
        <img style="width:480px" src="assets/img/logo-working_with-seal.svg">
      </div>
    </div>
  </div>
  <div class="container">
    <div class="justify-content-md-center row">
      <div class="col-md-auto text-white">
        <p>Redirecting to login...</p>
        <div class="m-loader m-loader--brand"></div>
      </div>
    </div>
  </div>
</div>
